import { render, staticRenderFns } from "./TextOnlyTeam.vue?vue&type=template&id=29ed7b71&scoped=true"
import script from "./TextOnlyTeam.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextOnlyTeam.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TextOnlyTeam.vue?vue&type=style&index=0&id=29ed7b71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ed7b71",
  null
  
)

export default component.exports